<div *ngIf="alertData != ''" class="alerts-wrapper"
    [ngClass]="currentPage === 'members' || currentPage ===  'state_processor_administrator' ? 'member-style': ''">
    <div class="container p-12 pl-20 pr-20" *ngFor="let alert of alertData"
        [ngClass]="[applyCss ? 'mt-24' : 'm-0', alert.alert_type == 2 ? 'amber-color' : 'accent-color']">
        <h2 *ngIf="alert.alert_title != ''" class="text-center font-weight-900 mt-8">{{alert.alert_title}}</h2>
        <div [innerHTML]="alert.alert_message | safeHtml"></div>
    </div>
</div>